<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 12.871 13.028">
        <g id="test-tube_1_" data-name="test-tube (1)" transform="translate(0 -1.616)">
            <path id="Path_69821" data-name="Path 69821"
                  d="M8.067,64.248a.845.845,0,0,0-1.2,1.2l.1.1L.7,71.815a2.407,2.407,0,0,0,3.4,3.4l6.27-6.27.1.1a.845.845,0,0,0,1.2-1.2ZM3.8,74.907a1.965,1.965,0,0,1-2.779-2.779l1.062-1.062H7.637Zm7.282-6.049a.406.406,0,0,1-.286-.118l-.415-.415-2.3,2.3H2.52l.792-.792.506.506.312-.312-.506-.506.35-.35.948.948.312-.312-.948-.948.35-.35.506.506.312-.312L4.949,68.2l.35-.35.948.948.312-.312-.948-.948.35-.35.506.506.312-.312-.506-.506.35-.35.948.948.312-.312-.948-.948.35-.35L9.56,68.131l.312-.312L7.184,65.131a.4.4,0,0,1,.286-.689.406.406,0,0,1,.286.118l3.609,3.608a.4.4,0,0,1-.285.689Zm0,0"
                  transform="translate(0 -61.28)" fill="#678fff"/>
            <path id="Path_69822" data-name="Path 69822"
                  d="M432.883,88a.883.883,0,1,0,.883.883A.884.884,0,0,0,432.883,88Zm0,1.325a.442.442,0,1,1,.442-.442A.442.442,0,0,1,432.883,89.325Zm0,0"
                  transform="translate(-420.896 -85.027)" fill="#678fff"/>
            <path id="Path_69823" data-name="Path 69823"
                  d="M320.662,25.325a.662.662,0,1,0-.662-.662A.663.663,0,0,0,320.662,25.325Zm0-.883a.221.221,0,1,1-.221.221A.221.221,0,0,1,320.662,24.442Zm0,0"
                  transform="translate(-311.168 -22.384)" fill="#678fff"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "ITubeNoBg",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
